import assign from "object-assign";
import * as poiActions from "./pois";
import * as nearbyPlacesActions from "./nearbyPlaces";

const actions = assign({}, poiActions, nearbyPlacesActions);

export default actions;



// WEBPACK FOOTER //
// ./assets/pois/actions/index.js